import React from "react";
import SiteFooter from "@/components/SiteFooter";
import { PsyGestionIcon } from "@/components/PsyGestionLogo";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  muted: "#6B85A3",
  border: "#D6E4F0",
  white: "#FFFFFF",
};

const sections = [
  {
    title: "1. Éditeur du site",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <p><strong>Nom commercial :</strong> PsyGestion</p>
        <p><strong>Éditeur :</strong> Freedom Architect</p>
        <p><strong>Forme juridique :</strong> Micro-entreprise</p>
        <p><strong>Email :</strong> <a href="mailto:contact@freedomarchitect.io" style={{ color: C.teal }}>contact@freedomarchitect.io</a></p>
        <p><strong>Site web :</strong> <a href="https://dashboard.freedomarchitect.io" style={{ color: C.teal }}>dashboard.freedomarchitect.io</a></p>
        <p><strong>Directeur de la publication :</strong> le gérant de Freedom Architect</p>
      </div>
    ),
  },
  {
    title: "2. Hébergement",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <p><strong>Application :</strong> Cloudflare Pages — Cloudflare Inc., 101 Townsend St, San Francisco, CA 94107, USA</p>
        <p><strong>Base de données et authentification :</strong> Supabase Inc., 970 Toa Payoh North #07-04, Singapore 318992 — Infrastructure AWS eu-west-1 (Irlande, UE)</p>
        <p><strong>Paiements :</strong> Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Dublin 2, Irlande</p>
      </div>
    ),
  },
  {
    title: "3. Nature du service",
    content:
      "PsyGestion est un outil d'aide à la gestion fiscale destiné aux psychologues exerçant en libéral. Il fournit des estimations et des simulations basées sur les taux fiscaux en vigueur (source ARAPL 2025, taux CIPAV). Ces informations sont données à titre purement indicatif et ne constituent en aucun cas un conseil fiscal, juridique ou comptable certifié. L'éditeur ne saurait être tenu responsable des décisions prises sur la base de ces estimations. Pour toute décision fiscale, consultez un expert-comptable ou un conseiller fiscal agréé.",
  },
  {
    title: "4. Propriété intellectuelle",
    content:
      "L'ensemble du contenu de PsyGestion (code source, design, textes, algorithmes de calcul, marque) est la propriété exclusive de Freedom Architect. Toute reproduction, représentation ou diffusion, totale ou partielle, par quelque procédé que ce soit, sans autorisation écrite préalable, est strictement interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.",
  },
  {
    title: "5. Données personnelles et RGPD",
    content:
      "Le traitement des données personnelles est décrit dans notre Politique de Confidentialité. Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et de limitation du traitement de vos données. Pour exercer ces droits : contact@freedomarchitect.io. Délai de réponse : 30 jours maximum.",
  },
  {
    title: "6. Limitation de responsabilité",
    content:
      "PsyGestion est fourni « en l'état ». L'éditeur s'efforce d'assurer l'exactitude des calculs mais ne garantit pas l'absence d'erreurs. L'utilisateur·rice reste seul·e responsable de ses déclarations fiscales et de l'utilisation des résultats fournis par l'outil. L'éditeur ne pourra en aucun cas être tenu responsable de tout dommage direct ou indirect résultant de l'utilisation ou de l'impossibilité d'utiliser le service.",
  },
  {
    title: "7. Droit applicable",
    content:
      "Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, le tribunal compétent est celui du ressort de Toulon (Var, France).",
  },
];

export default function MentionsLegales() {
  return (
    <div style={{ fontFamily: "'Inter', system-ui, -apple-system, sans-serif", backgroundColor: C.white, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <nav style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}`, padding: "16px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto", display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
            <PsyGestionIcon size={28} />
            <span style={{ fontWeight: 700, fontSize: 16, color: C.navy }}>PsyGestion</span>
          </a>
        </div>
      </nav>

      <main style={{ flex: 1, padding: "64px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: C.navy, marginBottom: 8 }}>
            Mentions légales
          </h1>
          <p style={{ fontSize: 13, color: C.muted, marginBottom: 48 }}>
            Dernière mise à jour : mars 2026
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            {sections.map((s) => (
              <div key={s.title}>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: C.navy, marginBottom: 10 }}>
                  {s.title}
                </h2>
                <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.8 }}>
                  {typeof s.content === "string" ? <p>{s.content}</p> : s.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
